import axios from 'axios'

export function getSchedule(locale, slug) {
  return axios.get('api/sales-static/schedules', {
    params: { slug, locale },
  })
}
